import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Story from "@/components/site/Story";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Location from "@/components/site/Location";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-root" className="min-h-screen bg-bone text-stone">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <Story />
      <Pricing />
      <Testimonials />
      <FAQ />
      <Location />
      <Footer />
    </main>
  );
}
